var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrivers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    fill: "#8f9fb4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 23,
    viewBox: "-0.001 0 18 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M18 23h-2.25v-2.19c0-1.815-1.511-3.286-3.375-3.286h-6.75c-1.865 0-3.375 1.47-3.375 3.285V23H0v-2.19c0-3.025 2.518-5.477 5.625-5.477h6.75c3.106 0 5.625 2.452 5.625 5.476V23zm-9-9.857c-3.729 0-6.75-2.942-6.75-6.572C2.25 2.942 5.27 0 9 0c3.728 0 6.75 2.942 6.75 6.571 0 3.63-3.022 6.572-6.75 6.572zm0-2.19c2.485 0 4.5-1.962 4.5-4.382s-2.015-4.38-4.5-4.38c-2.486 0-4.5 1.96-4.5 4.38s2.014 4.381 4.5 4.381z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivers);
export default __webpack_public_path__ + "static/media/drivers.7f371540e3555c1be455c274497dfdbe.svg";
export { ForwardRef as ReactComponent };